module.exports = __webpack_public_path__ + "0fb3c5f9865a9d373fea64fcc4e71f1b.png";